package com.essntl.features.area.ui.allareas

import com.essntl.features.area.domain.model.AreaModel

sealed interface AllAreasNavigation {
    data object AddArea : AllAreasNavigation
    data class EditArea(val area: AreaModel) : AllAreasNavigation
}